import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IRemarkCode } from "../types/remark-codes.types";
import { getRemarkCodes } from "../services/remark-codes.services";
import { IApiResponse } from "../../../utils/types/api-response";

export function useGetRemarkCodes(searchString?: string) {
    return useQuery<
        IApiResponse<IRemarkCode[]>,
        AxiosError<IApiResponse<IRemarkCode[]>>
    >({
        queryKey: ["remark-codes", searchString],
        queryFn: () => getRemarkCodes(searchString),
    });
}
